__turbopack_context__.v({
  "className": "bricolage_grotesque_e5032c0d-module__KnBhhG__className",
  "variable": "bricolage_grotesque_e5032c0d-module__KnBhhG__variable",
});
